import { render, staticRenderFns } from "./SettleCard.vue?vue&type=template&id=aa55b106&scoped=true&"
import script from "./SettleCard.vue?vue&type=script&lang=js&"
export * from "./SettleCard.vue?vue&type=script&lang=js&"
import style0 from "./SettleCard.vue?vue&type=style&index=0&id=aa55b106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55b106",
  null
  
)

export default component.exports